import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import FormGroup from '../../../../components/FormGroup';
import Input from '../../../../components/Input';
import MyModal from '../../../../components/Modal';

interface ISearchByNameModal {
  searchByNameModalShow: boolean;
  setSearchByNameModalShow: Dispatch<SetStateAction<boolean>>;
  searchByName: (code: string) => Promise<void>;
}

export default function SearchByNameModal({
  searchByNameModalShow,
  setSearchByNameModalShow,
  searchByName,
}: ISearchByNameModal) {
  const [userName, setUserName] = useState<string>('');

  function handleUserNameChange(event: ChangeEvent<HTMLInputElement>) {
    setUserName(event.target.value);
  }

  const [name, surname] = userName.split(' ');
  const isNameValid = name && surname && userName.length >= 3 && surname.length >= 3;
  const isValidToSearchByName = !!userName && isNameValid;

  return (
    <MyModal
      show={searchByNameModalShow}
      title={'Pesquisar por Nome'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Pesquisar'}
      onClose={() => setSearchByNameModalShow(false)}
      onAction={() => searchByName(userName)}
      isActionButtonDisabled={!isValidToSearchByName}
      type="action"
      size='lg'
      modalBody={(
        <FormGroup>
          <label htmlFor="contactName">Digite o Nome do usuário</label>
          <Input
            value={userName}
            onChange={handleUserNameChange}
            placeholder="Nome do usuário"
          />
        </FormGroup>
      )}
    />
  );
}
